
import ThemeProvider from "./Components/ThemeProvider";
import AppRouter  from "./routes/AppRouter";
import { RecoilRoot } from 'recoil';
import { SnackbarProvider } from 'notistack';

export default function App() {

  return (
    <RecoilRoot>
      <ThemeProvider>
      <SnackbarProvider maxSnack={3}>
        <AppRouter />
        </SnackbarProvider>
      </ThemeProvider>
    </RecoilRoot>
  );
}
